import React from 'react';
import DOMPurify from 'dompurify';

import styles from './HtmlText.module.scss';

type HtmlTextProps = {
  text: string;
};

const HtmlText: React.FC<HtmlTextProps> = ({ text }) => {
  return (
    <div
      className={styles['html-text']}
      dangerouslySetInnerHTML={{ __html: DOMPurify.sanitize(text) }}
    />
  );
};

export default React.memo(HtmlText);
